import { getAnalyticsAuthHeaders } from "./auth";

export const createQueue = ({ endpoint, maxBatch, flushIntervalMs }) => {
  let buffer = [];
  let timer = null;
  let flushing = false;

  const clearTimer = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const schedule = () => {
    if (timer || !buffer.length) return;
    timer = setTimeout(() => {
      timer = null;
      flush();
    }, flushIntervalMs);
  };

  const buildPayload = (events) => JSON.stringify({ events });

  const sendWithFetch = async (events, { keepalive = false } = {}) => {
    const authHeaders = getAnalyticsAuthHeaders();
    if (!authHeaders) {
      throw new Error("analytics sem JWT");
    }

    const headers = {
      "Content-Type": "application/json",
      ...authHeaders,
    };

    const response = await fetch(endpoint, {
      method: "POST",
      headers,
      body: buildPayload(events),
      keepalive,
    });

    if (!response.ok && response.status !== 202) {
      throw new Error(`analytics HTTP ${response.status}`);
    }
  };

  const flush = async ({ keepalive = false } = {}) => {
    if (flushing || !buffer.length || !endpoint) return;

    const authHeaders = getAnalyticsAuthHeaders();
    if (!authHeaders) return;

    const events = buffer.splice(0, maxBatch);
    flushing = true;
    clearTimer();

    try {
      await sendWithFetch(events, { keepalive });
    } catch {
      buffer = [...events, ...buffer].slice(0, maxBatch * 5);
    } finally {
      flushing = false;
      if (buffer.length) schedule();
    }
  };

  const enqueue = (event) => {
    if (!getAnalyticsAuthHeaders()) return;
    buffer.push(event);
    if (buffer.length >= maxBatch) {
      flush();
    } else {
      schedule();
    }
  };

  return { enqueue, flush };
};
